import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logOut } from "../redux/userslice";
import Context from '../Context/Context';
import { UserCircleIcon, ShoppingCartIcon } from '@heroicons/react/outline';
import { XIcon, MenuIcon } from '@heroicons/react/solid';
import logo from "../image/logo.png";

const Header = () => {
  const dispatch = useDispatch();
  const [login, setLogin] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);  // Track hamburger menu state
  const { count } = useContext(Context);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const token = localStorage.getItem("token");
  const location = useLocation();

  useEffect(() => {
    setLogin(!!token);
  }, [location, token]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    dispatch(logOut());
    setLogin(false);
    setDropdownOpen(false);
    window.location.href = '/';
    navigate("/");
  };

  const profile = () => {
    navigate("/profile");
    setDropdownOpen(false);
  };
  const order = () => {
    navigate("/order");
    setDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);  // Toggle the hamburger menu
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container">
        <Link className="navbar-brand" to="/">
        <img src={logo} alt="" width={25} className='me-2' />
        E-Commerce</Link>
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav" 
          aria-controls="navbarNav" 
          aria-expanded={isOpen ? 'true' : 'false'} 
          aria-label="Toggle navigation"
          onClick={toggleMenu}
        >
          {isOpen ? (
            <XIcon className="text-white" style={{ width: '24px', height: '24px' }} />
          ) : (
            <MenuIcon className="text-white" style={{ width: '24px', height: '24px' }} />
          )}
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <Link className="nav-link active" aria-current="page" to="/">Home</Link>
            </li>
            {user?.user?.role === 'ADMIN' ? (
              <li className="nav-item">
                <Link className="nav-link" to="/dashboard">Admin</Link>
              </li>
            ) : (
              <li className="nav-item">
                <Link className="nav-link" to="/Product">Product</Link>
              </li>
            )}
          </ul>
          
          <div className="d-flex align-items-center">
            {!login ? (
              <>
                <Link className="btn btn-outline-light me-2" to="/login">Login</Link>
                <Link className="btn btn-outline-light" to="/register">Register</Link>
              </>
            ) : (
              <div className="d-flex align-items-center gap-3">
                {/* Profile and Logout Links directly in navbar on mobile */}
                <div className="d-none d-lg-flex">
                  <button className="btn" type="button" onClick={toggleDropdown} aria-expanded={dropdownOpen}>
                    <UserCircleIcon className="text-white" style={{ width: '24px', height: '24px' }} />
                  </button>
                  {dropdownOpen && (
                    <ul className="dropdown-menu show" ref={dropdownRef} style={{top: "100%"}}>
                      <li><button className="dropdown-item" onClick={profile}>Profile</button></li>
                      <li><button className="dropdown-item" onClick={order}>Order</button></li>
                      <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
                    </ul>
                  )}
                </div>
                
                {/* Show Profile and Logout links on mobile screens */}
                <div className={`d-flex flex-column ${isOpen ? 'd-block' : 'd-lg-none'}`}>
                  <ul className="navbar-nav me-auto">
                  <li className="nav-item text-white" onClick={profile}>Profile</li>
                  <li className="nav-item text-white" onClick={order}>Order</li>
                  <li className="nav-item text-white" onClick={handleLogout}>Logout</li>
                  </ul>
                 
                </div>

                {/* Cart Icon */}
                <Link className="btn text-white position-relative" to="/cart">
                  <ShoppingCartIcon className="text-white" style={{ width: '24px', height: '24px' }} /> 
                  {count > 0 && (
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {count}
                    </span>
                  )}
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
